import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { JawaMark } from "@/components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("jawa_admin_token", res.data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full border border-jawa-espresso/20 bg-white px-4 py-3.5 text-sm text-jawa-espresso placeholder:text-jawa-espresso/40 focus:border-jawa-terracotta focus:outline-none transition-colors";

  return (
    <div className="flex min-h-screen items-center justify-center bg-jawa-ivory px-6" data-testid="admin-login-page">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm border border-jawa-stone bg-white p-10 shadow-sm"
      >
        <JawaMark className="h-12 w-12 text-jawa-espresso" />
        <h1 className="mt-6 font-serif text-3xl font-medium tracking-tight text-jawa-espresso">Owner Login</h1>
        <p className="mt-2 text-sm text-jawa-espresso/60">Manage guides, products and enquiries.</p>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          data-testid="admin-email-input"
          className={`${inputCls} mt-8`}
        />
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          data-testid="admin-password-input"
          className={`${inputCls} mt-4`}
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-6 w-full bg-jawa-espresso px-6 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-ivory transition-colors hover:bg-jawa-terracotta disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <a href="/" data-testid="admin-back-home" className="mt-5 block text-center text-xs uppercase tracking-[0.2em] text-jawa-espresso/50 hover:text-jawa-terracotta">
          Back to site
        </a>
      </form>
    </div>
  );
}
